import noop from 'utils/noop';

export const getCrashlytics = noop;
export const setAttribute = noop;
export const setAttributes = noop;
export const setUserId = noop;
export const log = noop;
export const recordError = noop;
export const sendUnsentReports = noop;
